export const phoneToWidgetFormat = (phone: string) => {
    return phone?.trim();
};

export const phoneToBackendFormat = (phone: string): string => {
    const cleaned = ('' + phone).replace(/\D/g, '');
    return '+' + cleaned;
};
